<div [hidden]="!isLoading">
  <span class="message">{{ message }}</span>
</div>
